<template>
  <div class="animated fadeIn">
    <p>
      <!-- Exit -->
      초기 설정 후 설정은 언제든지 변경할 수 있습니다
      <b-button class="float-right" variant="link" @click="$parent.$emit('toggle', false)">빠른 설정 종료</b-button>
    </p>
    <b-card-group>
      <b-card v-if="step == 1" class="slideInDown slideOutDown">
        <!-- 안내 및 설정 방법 -->
        <b-row>
          <b-col class="text-center">
            <h3>
              새 에이전트를 설치했습니다!
            </h3>
          </b-col>
        </b-row>
        <hr>
        <b-row>
          <b-col sm="12" class="text-center">
            <b-card-group deck style="cursor:pointer">
              <b-card bg-variant="primary" @click="list">
                <b-card-text>
                  <strong>
                    다른 서버에 설정을 복사하세요
                  </strong>
                  <hr>
                  <p>다른 웹 방화벽 설정을 해당 서버에 적용합니다</p>
                  <hr>
                  <p>
                    [에이전트 선택] -> [다른 서버에 적용] -> [저장]
                  </p>
                </b-card-text>
              </b-card>
              <b-card bg-variant="info" @click="next()">
                <b-card-text>
                  <p style="font-size: 1.7rem;">
                    정책 설정
                  </p>
                  <hr>
                  <p style="font-size: 1.4rem;">탐지 로그 확인을 위한 최소한의 정책을 적용합니다</p>
                </b-card-text>
              </b-card>
            </b-card-group>
          </b-col>
        </b-row>
      </b-card>
      <b-card v-if="step == 2" class="slideInLeft slideOutLeft">
        <b-row class="text-center">
          <b-col>
            <h4 class="mt-2">* 설치한 서버의 단계를 선택해주세요</h4>
            단계에 따라 사용하는 정책의 개수, 정책별 탐지, 차단에 차이가 존재합니다
            <strong>빠른 설정을 위한 단계로 이후 정책 최적화, 예외 처리등이 추가적으로 가능합니다</strong>
          </b-col>
        </b-row>
        <hr>
        <b-row class="">
          <b-col md="6">
            <VueApexCharts style="max-width:50%; margin: 0px auto;" type="pie" ref="_chart_policy" :options="info.chart.policy.option" :series="info.chart.policy.series" />
          </b-col>
          <b-col class="text-left">
              <!-- <b-form-radio style="cursor: pointer; display:block; margin:20px;" @change="change_level" v-model="level" name="level" value="0">
                테스트 단계
                <span class="text-info d-inline-block" v-b-tooltip.hover.bottom="'테스트하기 위한 단계로 정책마다 사용 테스트를 위한 단계입니다 PoC 진행시 사용합니다'">
                  <i class="fa fa-question-circle"></i>
                </span>
                <br>
                (전부 미사용, 단계적 활성화)

              </b-form-radio>

              <b-form-radio style="cursor: pointer; display:block; margin:20px;" @change="change_level" v-model="level" name="level" value="1">
                초기 단계
                <span class="text-info d-inline-block" v-b-tooltip.hover.bottom="'처음 설치 및 테스트 모드로 사용시 설정하는 단계입니다 OWASP TOP 10 등 일반적인 정책 탐지로 설정하여 유입되는 공격 유형을 확인합니다'">
                  <i class="fa fa-question-circle"></i>
                </span>
                <br>
                (OWASP TOP 10 등 탐지 위주)

              </b-form-radio>
              <b-form-radio style="cursor: pointer; display:block; margin:20px;" @change="change_level" v-model="level" name="level" value="1.5">
                초기 확장 단계
                <span class="text-info d-inline-block" v-b-tooltip.hover.bottom="'제외 정책을 제외한 모든 정책이 탐지 모드로 설정됩니다 차단 전에 권장하는 정책 단계입니다'">
                  <i class="fa fa-question-circle"></i>
                </span>
                <br>
                (OWASP TOP 10 등 탐지 위주, 의심 공격 탐지)

              </b-form-radio> -->


              <b-form-radio style="cursor: pointer; display:block; margin:20px;" @change="change_level" v-model="level" name="level" value="0">
                테스트 단계
                <span class="text-info d-inline-block" v-b-tooltip.hover.bottom="'테스트하기 위한 단계로 정책마다 사용 테스트를 위한 단계입니다 PoC 진행시 사용합니다'">
                  <i class="fa fa-question-circle"></i>
                </span>
                <br>
                (전부 미사용, 단계적 활성화)

              </b-form-radio>

              <b-form-radio style="cursor: pointer; display:block; margin:20px;" @change="change_level" v-model="level" name="level" value="1">
                탐지 단계
                <span class="text-info d-inline-block" v-b-tooltip.hover.bottom="'처음 설치 및 테스트 모드로 사용시 설정하는 단계입니다 OWASP TOP 10 등 일반적인 정책 탐지로 설정하여 유입되는 공격 유형을 확인합니다'">
                  <i class="fa fa-question-circle"></i>
                </span>
                <br>
                (OWASP TOP 10 등 정책 탐지 모드, 제외 정책 제외)

              </b-form-radio>
              <b-form-radio style="cursor: pointer; display:block; margin:20px;" @change="change_level" v-model="level" name="level" value="2">
                차단 단계
                <span class="text-info d-inline-block" v-b-tooltip.hover.bottom="'탐지 기간을 일정 기간 운영 후, OWASP TOP 10 과 같은 기본적인 공격을 차단하는 단계입니다'">
                  <i class="fa fa-question-circle"></i>
                </span>
                <br>
                (전체 정책 차단 설정, 제외 정책 제외)

              </b-form-radio>
          </b-col>
          <!-- <b-col class="text-left">
            <b-form-radio style="cursor: pointer; display:block; margin:20px;" @change="change_level" v-model="level" name="level" value="2">
              중기 단계
              <span class="text-info d-inline-block" v-b-tooltip.hover.bottom="'탐지 기간을 일정 기간 운영 후, OWASP TOP 10 과 같은 기본적인 공격을 차단하는 단계입니다'">
                <i class="fa fa-question-circle"></i>
              </span>
              <br>
              (일반적인 공격 차단)

            </b-form-radio>
            <b-form-radio style="cursor: pointer; display:block; margin:20px;" @change="change_level" v-model="level" name="level" value="3">
              장기 단계
              <span class="text-info d-inline-block" v-b-tooltip.hover.bottom="'적정한 탐지와 차단을 혼용하여 설정하는 단계입니다 사이트가 많을수록 많은 오탐이 발생할 수 있으며 정책 최적화가 필요합니다'">
                <i class="fa fa-question-circle"></i>
              </span>
              <br>
              (차단 위주, 공격 의심 차단)

            </b-form-radio>
            <b-form-radio style="cursor: pointer; display:block; margin:20px;" @change="change_level" v-model="level" name="level" value="4">
              최종 단계
              <span class="text-info d-inline-block" v-b-tooltip.hover.bottom="'제외 정책을 제외하고 최종적으로 차단 운영을 권장하는 단계입니다 전체적인 공격을 차단하는 단계로 어느정도 정책 최적화가 진행 된 후에 설정을 권장합니다'">
                <i class="fa fa-question-circle"></i>
              </span>
              <br>
              (모든 정책 차단, 고도화 차단, 연계성 공격 차단)
            </b-form-radio>
        </b-col> -->
        </b-row>
      </b-card>
      <b-card v-if="step == 3" class="slideInLeft slideOutLeft">

      </b-card>
    </b-card-group>
    <!-- 스탭 공통 처리 부분 -->
    <hr v-if="step < all">
    <b-button v-if="step > 1" block size="sm" variant="info" @click="prev()"> 이전 </b-button>
    <b-button v-if="step < 2"  block size="sm" variant="primary" @click="next()">다음 </b-button>
    <b-button v-if="step == 2" class="btn-add"  block size="sm" variant="success" @click="modal_save = true">저장 </b-button>
    <hr>
    <b-row>
      <b-col>
        <center>{{step}} / {{all}}</center>
      </b-col>
    </b-row>
    <b-modal title="Policy Apply to agent(WAF)"  class="modal-success" v-model="modal_save" @ok="apply" ok-variant="success" header-bg-variant="warning">
      설정을 적용할까요 ?
      <hr>
      저장 이후 빠른 설정은 다시 시작할 수 있습니다
    </b-modal>
  </div>
</template>

<script>
import App from './app.js'; export default Object.assign({}, App);
</script>
